var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import bsearch from "@namhong2001/binary-search";
import { useCallback, useEffect, useRef, } from "react";
const Textfit = (_a) => {
    var { children, mode = "multi", min = 0, max = 300 } = _a, props = __rest(_a, ["children", "mode", "min", "max"]);
    const ref = useRef(null);
    const isOverflown = useCallback(() => {
        const el = ref.current;
        return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
    }, []);
    const setFontSize = useCallback(() => {
        const el = ref.current;
        const originVisibility = el.style.visibility;
        el.style.visibility = "hidden";
        const fontSize = bsearch(min, max + 1, (mid) => {
            el.style.fontSize = `${mid}px`;
            return !isOverflown();
        });
        el.style.fontSize = `${fontSize}px`;
        el.style.visibility = originVisibility;
    }, [isOverflown, min, max]);
    useEffect(() => {
        const el = ref.current;
        setFontSize();
        const observer = new ResizeObserver(setFontSize);
        observer.observe(el);
        return () => {
            observer.disconnect();
        };
    }, [children, mode, setFontSize]);
    return (_jsx("div", Object.assign({ ref: ref, style: {
            whiteSpace: mode === "single" ? "nowrap" : "normal",
        } }, props, { children: children })));
};
export default Textfit;
